// extracted by mini-css-extract-plugin
export var hidden = "_qp-1";
export var visible = "_qp-0";